import { render, staticRenderFns } from "./GALLERY.vue?vue&type=template&id=2b267301&"
import script from "./GALLERY.vue?vue&type=script&lang=js&"
export * from "./GALLERY.vue?vue&type=script&lang=js&"
import style0 from "./GALLERY.vue?vue&type=style&index=0&id=2b267301&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports